import authEnum from "./baseAuthEnum";

const baseAuth = [
    {
        title : '系统设置',
        checkAll : [
            authEnum.EDIT_COMPANY_GROUP,
            authEnum.TAB_MANAGE,
            authEnum.ITEM_PROGRESS_MANAGE,
            authEnum.CARRIER_PROGRESS_MANAGE,
            authEnum.WATCH_CARD_RECORD,
            authEnum.EDIT_COMPANY_INFO,
            authEnum.EDIT_COMPANY_USER_INFO,
            authEnum.AUTH_SETTING,
            authEnum.CHANGE_USER_STATUS,
            authEnum.SET_ADMINISTRATIVE_AREA,
            authEnum.SET_BELONG_AREA,
            authEnum.SET_ITEM_ORIGIN,
            authEnum.SET_FILE_CATEGORY,
            authEnum.ADD_USER,
            authEnum.SET_PROFESSION_CATEGORY,
            // authEnum.SET_COMPANY_AREA,
        ],
        authList : [
            {name:"单位分组修改",value:authEnum.EDIT_COMPANY_GROUP},
            {name:"标签管理",value:authEnum.TAB_MANAGE},
            {name:"项目进度管理",value:authEnum.ITEM_PROGRESS_MANAGE},
            {name:"载体进度管理",value:authEnum.CARRIER_PROGRESS_MANAGE},
            {name:"查看名片统计",value:authEnum.WATCH_CARD_RECORD},
            {name:"编辑单位资料",value:authEnum.EDIT_COMPANY_INFO},
            {name:"编辑成员资料",value:authEnum.EDIT_COMPANY_USER_INFO},
            {name:"权限设置",value:authEnum.AUTH_SETTING},
            {name:"禁止用户登录",value:authEnum.CHANGE_USER_STATUS},
            {name:"行政区划管理",value:authEnum.SET_ADMINISTRATIVE_AREA},
            {name:"所属区域管理",value:authEnum.SET_BELONG_AREA},
            {name:"项目来源管理",value:authEnum.SET_ITEM_ORIGIN},
            {name:"附件管理",value:authEnum.SET_FILE_CATEGORY},
            {name:"添加成员",value:authEnum.ADD_USER},
            {name:"专业类别管理",value:authEnum.SET_PROFESSION_CATEGORY},
            // {name:"企业区域管理",value:authEnum.SET_COMPANY_AREA},
        ],
    },
    {
        title : "企业权限",
        checkAll : [
            authEnum.EXPORT_ENTERPRISE,
            authEnum.RECYCLE_ENTERPRISE,
            // authEnum.APPROVE_ENTERPRISE,
            // authEnum.ADD_INTEGRAL,
            // authEnum.VIEW_REPORT,
            // authEnum.IMPORT_REPORT,
            // authEnum.ENTERPRISE_ACCOUNT_CONFIG,
            // authEnum.BAN_ENTERPRISE_ACCOUNT,
        ],
        authList : [
            {name:"导出企业",value:authEnum.EXPORT_ENTERPRISE},
            {name:"回收企业",value:authEnum.RECYCLE_ENTERPRISE},
            // {name:"企业审核",value:authEnum.APPROVE_ENTERPRISE},
            // {name:"企业积分录入",value:authEnum.ADD_INTEGRAL},
            // {name:"查看报表",value:authEnum.VIEW_REPORT},
            // {name:"上传佛高新报表",value:authEnum.IMPORT_REPORT},
            // {name:"企业账户管理",value:authEnum.ENTERPRISE_ACCOUNT_CONFIG},
            // {name:"禁止企业账户登录",value:authEnum.BAN_ENTERPRISE_ACCOUNT}
        ],
    },
    {
        title : '项目权限',
        checkAll : [
            authEnum.EXPORT_ITEM,
        ],
        authList : [
            {name:"导出项目",value:authEnum.EXPORT_ITEM},
        ],
    },
    {
        title : '载体权限',
        checkAll : [
            authEnum.EXPORT_CARRIER,
        ],
        authList : [
            {name:"导出载体",value:authEnum.EXPORT_CARRIER},
        ],
    },

    {
        title : '数据权限',
        checkAll : [
            authEnum.DATA_MODULE_ENTRY,
            authEnum.EXPORT_DATA,
        ],
        authList : [
            {name:"数据模块",value:authEnum.DATA_MODULE_ENTRY},
            // {name:"导出数据",value:authEnum.EXPORT_DATA},
        ],
    },
];

export default baseAuth;


// WEBPACK FOOTER //
// ./src/staticData/baseAuth.js